import listReducer from './list/reducer';

export default {
  jiaolianList: listReducer,
};
